<template>
  <div class='lm-product-intro'>
    <h2>MoPaaS大模型 AI 平台</h2>
    <div class="box">
      <div class="content">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;MoPaaS大模型AI 平台为用户提供从算力优化到LLMOps的全栈大模型应用工程解决方案。大模型AI平台基于自主研发的MoPaaS AI平台技术架构，端到端地实现生成式 AI 应用开发与部署流程，涵盖从大模型资产管理、模型训练/微调、提示工程到模型部署的大模型全生命周期。大模型AI 平台使用户可以在其专有、安全、合规环境中进行大模型相关的实验、协作、训练和推理，打造满足其场景需求的专有大模型和应用。</div>
      <img src="../../assets/images/lm-intro-h5-1.png"/>
      <img src="../../assets/images/lm-intro-h5-2.png"/>
    </div>
    </div>
</template>

<script>
export default {
  name: 'LmIntrodution'
}
</script>

<style>
.lm-product-intro {
  background: #F5F6F9;
  padding: 6vw 3vw;
}

.lm-product-intro h2 {
  margin: 0 auto 6vw;
  font-size: 16px;
  font-weight: 500;
  color: #3A3F4D;
  line-height: 20px;
}

.lm-product-intro .box {
  width: 100vw;
}

.lm-product-intro .box img {
  width: 94vw;
  height: 55vw;
  margin-top: 2vh;
}
.lm-product-intro .content {
  font-size: 12px;
  font-weight: 400;
  color: #333333;
  line-height: 18px;
  text-align: left;
  margin: 4vw 2vw 0;
}
</style>
<style></style>


// WEBPACK FOOTER //
// src/page/h5/lm-introduction.vue